import React, { useState } from 'react';
import { Row, Col, Stack, Image } from 'react-bootstrap';
import DragIndicatorIcon from 'assets/images/Category/DragIndicatorIcon.png';
import CheckBoxInput from 'components/common/Input/CheckBoxInput';
import DescriptionIcon from 'assets/images/Category/DescriptionIcon.png';
import DeleteIcon from 'assets/images/Category/DeleteIcon.png';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FormattedMessage } from 'react-intl';
import CustomPopover from 'components/common/CustomPopover';
import { ShimmerBox, ShimmerCircle } from 'components/common/Shimmer';

const SubServiceList = ({
  services,
  onEdit,
  onCheckBoxEnableDisable,
  onDelete,
  onReadOnly,
  onView,
  loading,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewData, setViewData] = useState('');

  const handlePopoverClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setViewData(item);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const PopoverData = [];

  if (onReadOnly) {
    PopoverData.push({
      label: <FormattedMessage id="View Service" />,
      icon: <Image src={DescriptionIcon} style={{ marginRight: '5px' }} />,
      onClick: () => onView(viewData),
    });
  } else {
    PopoverData.push({
      label: <FormattedMessage id="Edit Service" />,
      icon: <Image src={DescriptionIcon} style={{ marginRight: '5px' }} />,
      onClick: () => onEdit(viewData),
    });

    PopoverData.push({
      label: <FormattedMessage id="Delete" />,
      icon: <Image src={DeleteIcon} style={{ marginRight: '5px' }} />,
      onClick: () => onDelete(viewData),
    });
  }

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <Row className="m-0 p-0 mt-3">
      {loading ? (
        <>
          {[1, 2, 3].map((item) => (
            <Row key={item} className="m-0 p-0 flex items-center border-b py-4">
              <Col md={6}>
                <div className="flex items-center gap-2">
                  <ShimmerBox width="32px" height="32px" />
                  <ShimmerBox width="32px" height="32px" />
                  <ShimmerCircle size="50px" />
                  <ShimmerBox width="200px" height="16px" />
                </div>
              </Col>
              <Col md={3}>
                <div className="flex items-center gap-5">
                  <ShimmerBox width="80px" height="14px" />
                  <ShimmerBox width="60px" height="14px" />
                </div>
              </Col>
              <Col md={3}>
                <div className="flex justify-end">
                  <ShimmerBox width="24px" height="24px" />
                </div>
              </Col>
            </Row>
          ))}
        </>
      ) : services?.length > 0 ? (
        services.map((service, index) => (
          <Row
            key={service.id}
            className={`m-0 p-0 flex items-center  ${services?.length === index + 1 ? 'pt-4' : 'border-b py-4'}`}
          >
            {onEdit ? (
              <Col md={6} className="items-center">
                <div className="flex items-center gap-2">
                  <img
                    src={DragIndicatorIcon}
                    alt={'icon'}
                    style={{ height: '32px', width: '32px' }}
                  />
                  {service?.provider_product_admin && (
                    <CheckBoxInput
                      height={'32px'}
                      onChange={() => onCheckBoxEnableDisable(service)}
                      checked={
                        service?.provider_product_admin && service?.is_public
                      }
                    />
                  )}
                  <>
                    {service?.service_images?.[0]?.url && (
                      <img
                        src={service?.service_images?.[0]?.url}
                        alt="icon"
                        style={{ height: '50px', width: '50px' }}
                      />
                    )}
                    <span className="service-name font-bold">
                      {service.product_name}
                    </span>
                  </>
                </div>
              </Col>
            ) : (
              <Col md={6} className="items-center">
                <p className="service-name font-bold">{service.name}</p>
              </Col>
            )}

            <Col md={3}>
              <div className="flex items-center gap-5">
                <span className="service-price text-gray-600">
                  {service.price} {service.currency}
                </span>
                <span className="service-time text-gray-600">
                  {service.time_required_in_mints} min
                </span>
              </div>
            </Col>

            <Col md={3} className="">
              <Stack
                direction="horizontal"
                gap={4}
                className="items-center justify-end"
              >
                {service?.provider_product_admin && (
                  <div>
                    <MoreVertIcon
                      aria-describedby={id}
                      style={{ fill: '#3C1053', cursor: 'pointer' }}
                      onClick={(e) => handlePopoverClick(e, service)}
                    />
                    <CustomPopover
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      handleClose={handlePopoverClose}
                      options={PopoverData}
                    />
                  </div>
                )}
              </Stack>
            </Col>
          </Row>
        ))
      ) : null}
    </Row>
  );
};

export default SubServiceList;
